export const replaceLocation = (url: string) => {
  globalThis.location.replace(url);
};
